<template>
  <div id="app" class="tonos-app">
    <router-view />
  </div>
</template>
<script>
import 'vue-toastification/dist/index.css';

export default {};
</script>

<style lang="scss">
:root {
  --tonos-accent-color: #1d79f2;
  --tonos-accent-color-dark: #196cd8;
  --tonos-accent-color-darker: #1d417b;
  --tonos-accent-color-shadow: 0 0 0 1px #1d79f2;
  --tonos-accent-color-outline-shadow: rgb(33 145 242 / 25%) 0px 0px 0px 0.25em;
}

// @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap');

.loading-spinner {
  color: var(--tonos-accent-color) !important;
  width: 22px !important;
  height: 22px !important;

  &.small-spinner {
    width: 16px !important;
    height: 16px !important;
    border-width: 2px;
  }
}

.loading-spinner-icon {
  color: #2c2c2c !important;
  border-width: 0.12em;
  width: 15px;
  height: 15px;
}

.loading-spinner-button {
  width: 17px !important;
  height: 17px !important;
  color: white;
}

.tonos-app,
#offer,
#form-response,
.offer {
  width: 100%;
  min-height: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
html,
body,
.tonos-app {
  background-color: transparent !important;
  min-height: 100% !important;
  width: 100%;
  font-size: initial;
  display: flex;
}

.tonos-app {
  height: 100%;
  display: block;

  * {
    font-family: 'Inter', sans-serif;
  }
}
</style>
